<body>
    <div class="container">
        <h1 class="title">Time Table Form</h1>
        <form [formGroup]="form">
            <div class="trip-details">
                <label class="labels">Número da viagem</label>
                <input class="input-box" type="number" placeholder="Digite o número" class="form-control"
                    formControlName="viagem" [disabled]="form.controls['viagem'].disabled">
                <label class="labels">Tipo</label>
                <input class="input-box" type="text" placeholder="Digite o tipo" class="form-control"
                    formControlName="tipo">
                <label class="labels">Destino</label>
                <input class="input-box" type="text" placeholder="Digite o Destino" class="form-control"
                    formControlName="destino">
            </div>

            <div class="trip-type">
                <legend class="labels">Tipo de viagem</legend>
                <div class="category">
                    <label for="dot-1">
                        <input type="radio" class="dot one" formControlName="trip" value="extra">
                        <span>Viagem Extra</span>
                    </label>
                    <label for="dot-2">
                        <input type="radio" class="dot two" formControlName="trip" value="standart">
                        <span>Viagem Padrão</span>
                    </label>
                </div>
            </div>

            <div class="common-trip">
                <div class="form-group">
                    <label class="labels">Início LCB</label>
                    <input class="input-box form-control" type="text" placeholder="hh:mm" maxlength="5"
                        formControlName="inicioLCB" (input)="formatTime($event)">
                </div>

                <div class="form-group">
                    <label class="labels">Saída LCB</label>
                    <input class="input-box form-control" type="text" placeholder="hh:mm" maxlength="5"
                        formControlName="saidaLCB" (input)="formatTime($event)">
                </div>

                <div class="form-group">
                    <label class="labels">Início SLA</label>
                    <input class="input-box form-control" type="text" placeholder="hh:mm" maxlength="5"
                        formControlName="inicioSLA" (input)="formatTime($event)">
                </div>

                <div class="form-group">
                    <label class="labels">Saída SLA</label>
                    <input class="input-box form-control" type="text" placeholder="hh:mm" maxlength="5"
                        formControlName="saidaSLA" (input)="formatTime($event)">
                </div>
            </div>

            <div class="extra-trip">
                <label class="labels">TAKT (Viagem Extra)</label>
                <input class="input-box form-control" type="text" placeholder="hh:mm" maxlength="5"
                    formControlName="extra" (input)="formatTime($event)">
            </div>

            <div class="action-buttons">

                <button (click)="isNewTrip() ? submitForm() : updateTrip()" class="btn-save">
                    {{ isNewTrip() ? 'Salvar' : 'Atualizar' }}
                  </button>
                <button (click)="resetForm()" class="btn-clear">Limpar</button>
            </div>
            <div class="close-div">
                <button (click)="onClose()" class="btn-cs">Sair</button>
            </div>
        </form>
    </div>
</body>